<template>
    <Loading v-if="loading" />
    <div class="modal is-active" v-else>
        <div class="modal-background"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">{{ $t("finish-modal.title") }}</p>
            </header>
            <section class="modal-card-body">
                <div>
                    <p>{{ $t("finish-modal.room-finished") }}</p>
                    <div
                        class="
                            is-flex
                            is-flex-direction-column
                            is-justify-content-center
                        "
                    >
                        <div class="flex-centered-content p-2">
                            <button class="button is-link" @click="goCallInfo">
                                {{ $t("finish-modal.go-room-info") }}
                            </button>
                        </div>
                        <Separator :text="$t('finish-modal.or')" />
                        <div class="flex-centered-content p-2">
                            <QR
                                v-if="url !== ''"
                                :text="url"
                                :size="200"
                                error-level="L"
                            />
                        </div>
                    </div>
                </div>
            </section>
            <footer class="modal-card-foot">
                <button class="button" @click="goHome">
                    {{ $t("finish-modal.close") }}
                </button>
            </footer>
        </div>
    </div>
</template>

<script>
import QR from "vue-qr-generator";
import Separator from "@/components/Separator";

import { mapGetters } from "vuex";

export default {
    name: "finish-modal",
    components: {
        QR,
        Separator,
    },
    props: {
        roomId: {
            typer: String,
            required: true,
        },
    },
    data() {
        return {
            routerParams: {},
            url: "",
            loading: false,
        };
    },
    mounted() {
        if (this.isOperator) {
            this.loading = true;
            let url = this.$router.resolve({ name: "online-operator" });
            window.location.href = url.href;
        }

        this.routerParams = {
            name: "room-info",
            params: { roomId: this.roomId },
        };

        const host = window.location.host;
        const href = this.$router.resolve(this.routerParams).href;
        this.url = `${host}${href}`;
    },
    computed: {
        ...mapGetters("oidcStore", ["oidcIsAuthenticated", "oidcUser"]),
        isLogged() {
            return this.oidcIsAuthenticated;
        },
        isOperator() {
            if (!this.isLogged) {
                return false;
            }
            let roles = this.oidcUser?.role;
            return roles.indexOf("Operador") > -1;
        },
    },
    methods: {
        async goHome() {
            if (this.isLogged) {
                let url = this.$router.resolve({ name: "home" });
                window.location.href = url.href;
            } else {
                window.location.href = "https://bio-te.azurewebsites.net/";
            }
        },
        goCallInfo() {
            this.$router.push(this.routerParams);
        },
    },
};
</script>

<style lang="scss" scoped>
.flex-centered-content {
    display: flex;
    justify-content: center;
}
</style>